import { CONFIG } from '../../core/config';
import { RunnableModelMetadata } from '../runnable-model-metadata';
import { ViewModel } from '../view-model';
import { OrgTreeNodeModelRunCategory } from './org-tree-node-model-run-category';
import { OrgTreeNodeModelRunInput } from './org-tree-node-model-run-input';
import { OrgTreeNodeModelRunOutput } from './org-tree-node-model-run-output';

export class OrgTreeNodeModelRun implements ViewModel {
  public readonly friendlyTypeNameSingular = 'Org Tree Node Model Run';
  public readonly apiRoute: string = CONFIG.apiRoutes.orgTreeNodeModelRun;

  orgTreeNodeModelRunId: string;
  orgTreeNodeId: string;
  modelId: string;
  model: RunnableModelMetadata;
  name: string;
  scenarioType: OrgTreeNodeModelRunScenarioType;
  scenarioTypeName: string;
  analysisDate: Date;
  createdBy: string;
  creationDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  comments: string;

  displayMethod: string;
  inputs: OrgTreeNodeModelRunInput[] = [];
  outputs: OrgTreeNodeModelRunOutput[] = [];
  categories: OrgTreeNodeModelRunCategory[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    if (!data) {
      return;
    }

    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunId;

    this.orgTreeNodeId = data.orgTreeNodeId;
    this.modelId = data.modelId;

    if (data.model) {
      this.model = new RunnableModelMetadata();
      this.model.loadFromJson(data.model);
    }

    this.name = data.name;
    this.scenarioType = data.scenarioType;
    this.scenarioTypeName = this.getScenarioTypeName(this.scenarioType);
    this.analysisDate = data.analysisDate;

    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedDate = data.lastModifiedDate;

    if (data.model?.displayMethod) {
      this.displayMethod = data.model.displayMethod.displayMethodName;
    }

    this.comments = data.comments;

    if (data.inputs) {
      data.inputs.forEach(input => {
        const newInput = new OrgTreeNodeModelRunInput();

        newInput.loadFromJson(input);
        this.inputs.push(newInput);
      });
    }

    if (data.outputs) {
      data.outputs.forEach(output => {
        const newOutput = new OrgTreeNodeModelRunOutput();

        newOutput.loadFromJson(output);
        this.outputs.push(newOutput);
      });
    }

    if (data.categories) {
      data.categories.forEach(cat => {
        const newCat = new OrgTreeNodeModelRunCategory();

        newCat.loadFromJson(cat);
        this.categories.push(newCat);
      });
    }
  }

  private getScenarioTypeName(scenarioType: OrgTreeNodeModelRunScenarioType): string {
    switch (scenarioType) {
      case OrgTreeNodeModelRunScenarioType.Driving:
        return 'Driving';

      case OrgTreeNodeModelRunScenarioType.WhatIf:
        return 'What-If';

      case OrgTreeNodeModelRunScenarioType.DrivingHistorical:
        return 'Driving (archived)';

      default:
        console.error('Can not retrieve scenario type name - scenario type is unknown.');

        return '';
    }
  }
}

export enum OrgTreeNodeModelRunScenarioType {
  Driving = 1,
  WhatIf = 2,
  DrivingHistorical = 3,
}
